import { Component, Input, Output, EventEmitter, DoCheck, OnChanges } from '@angular/core';
import { FormAutoFocusComponent } from '../formautofocus/formAutoFocus.component';

@Component({
    selector: 'yearselector',
    template: require('./yearselector.component.html')
})

export class YearselectorComponent extends FormAutoFocusComponent implements DoCheck, OnChanges {

    @Input() required: boolean = false;
    @Input() name: string;

    yearValues: Array<number>;
    @Input('startYear') startYear: number;
    selectedValue: number;

    @Input()
    get selectedYear() {
        return this.selectedValue;
    }

    set selectedYear(val) {
        this.selectedValue = val;
        this.selectedYearChange.emit(this.selectedYear);
        
    }

    @Output() selectedYearChange: EventEmitter<number> = new EventEmitter();

    //@Output() onChange: Subject<any> = new Subject<any>();
    
    constructor() {
        super();
        this.yearValues = new Array<number>();
        this.startYear = new Date().getFullYear();
    }
    
    ngOnInit() {
        if (this.startYear > 0) {
            for (let c = this.startYear; c < this.startYear + 4; c++) {
                this.yearValues.push(c);
            }
        }
    }

    ngOnChanges(changes: Object): void {
        
    }

    ngDoCheck() {
        
    }
    
}




// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/yearselector/yearselector.component.ts